const { Mixin } = Shopware;

export default {
    mixins: [
        Mixin.getByName('cms-element'),
    ],

    computed: {
        isBlogPage() {
            return this.cmsPageState?.currentPage?.type ?? '' === 'cms_blog';
        },
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-image');
            this.initElementData('acris-blog-image');

            if (this.isBlogPage && !this.element?.translated?.config?.media) {
                this.element.config.media.source = 'mapped';
                this.element.config.media.value = 'acris_blog.media';
            }
        }
    },
};
